import axios from "axios";
import CookieManager from "./CookieManager";
import { ObjectHelper } from "./ObjectHelper";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlBaseResponse } from "../models/service-models/common/BaseResponse";
import { toast } from "react-toastify";
import { InputHelper } from "./InputHelper";
import { enmContentType } from "../models/enums/ContentType";

export async function GetResponse<T extends mdlServiceResponse<mdlBaseResponse>>(
  requestUrl: string,
  requestObj: any,
  contentType: enmContentType = enmContentType.Json
): Promise<T> {
  let apiUrl = process.env.REACT_APP_API_ADDRESS;
  let currentLanguage = CookieManager.get("language");
  if(requestObj["currentLanguage"] != undefined){
    currentLanguage = requestObj["currentLanguage"];
  }else if (InputHelper.isNullOrUndefinedOrEmpty(currentLanguage)) {
    currentLanguage = "en-US";
  }
  if(contentType == enmContentType.Json){
      return await PostAsync<T>(
        apiUrl + "/" + requestUrl,
        JSON.stringify({ ...requestObj, currentLanguage: currentLanguage })
      );
  }
  return await PostAsyncFormData<T>(
    apiUrl + "/" + requestUrl,
    requestObj 
  );
}

function PostAsyncFormData<T>(url: string, request: FormData) {
  let token = CookieManager.get("authToken");
  var headers = [];
  if (token) {
    headers.push({ key: 'Authorization', value: "Bearer " + token });
  }
  return AsyncSendFormData<T>('POST', headers, url, request);
}

function AsyncSendFormData<T>(type: string, headers: { key: string, value: string }[], url: string, request: FormData,
  timeout?: number, dataType?: 'json' | 'text' | 'blob' | 'document'): Promise<T> {
  return new Promise<T>(function (resolve, reject) {

      var xhr = new XMLHttpRequest();
      xhr.open(type, url, true);
      headers.forEach((h) => {
          xhr.setRequestHeader(h.key, h.value);
      });
      if (dataType != null)
          xhr.responseType = dataType;

      xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
              if (!xhr.response.includes("<!DOCTYPE html>")) {
                  let typedResponse: T = JSON.parse(xhr.response);
                  resolve(typedResponse);
              }
          } else {
              reject({
                  status: xhr.status,
                  statusText: xhr.statusText
              });
          }
      };
      xhr.onerror = function () {
          reject({
              status: xhr.status,
              statusText: xhr.statusText
          });
      };
      xhr.send(request);
  });

}
function PostAsync<T>(url: string, request: string) {
  return AsyncSend<T>("post", url, request);
}

async function AsyncSend<T>(
  type: string,
  url: string,
  request: string
): Promise<T> {
  return new Promise<T>(function (resolve, reject) {
    let token = CookieManager.get("authToken");
    let headers: any = {
      "Content-Type": "application/json"
    }
    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }
    try {
      axios({
        headers: headers,
        method: type,
        url: `${url}`,
        data: request,
        timeout: 240000,
      })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            let typedResponse: T = response.data;
            resolve(typedResponse);
          } else {
            toast.error(response.headers.message);
            reject({
              status: response.status,
              statusText: response.statusText,
            });
          }
        })
        .catch((error) => {
          toast.error(error.message);
          var response = ObjectHelper.prepareResponseHeader("An error occured");
          resolve(response as T);
        });
    } catch (err) {
      console.log(err);
      var response = ObjectHelper.prepareResponseHeader("An error occured");
      resolve(response as T);
    }
  });
}
